import { Breadcrumb } from "@components/anti/Breadcrumb"
import { Cover } from "@components/anti/Cover"
import SectionFindCinema from "@components/global/SectionFindCinema"
import ProductsServicesCinemaFacilities from "@components/pages/products-services/products-services-cinema-facilities"
import ProductsServicesCinemaOverview from "@components/pages/products-services/products-services-cinema-overview"
import ProductsServicesConcessionsLocation from "@components/pages/products-services/products-services-concessions-location"
import { getPostCategoriesByType, getPostCategoryBySlug } from "lib/api"
import { metaDesc } from "src/helper/meta-desc"
import { linkProductsServices } from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { extractMeta, imgUrl } from "src/mixins"

function ConcessionDetailPage({ data, locale }) {
  const pageData = data?.meta
  const hero = extractMeta(pageData, "hero")
  const menu = extractMeta(pageData, "menu")
  return (
    <>
      <Cover
        title={data && data[`title_${locale}`]}
        text={data && data[`description_${locale}`]}
        img={imgUrl(hero?.banner_image_mobile)}
        imgMd={imgUrl(hero?.banner_image_desktop)}
        imgHeight="h-vh-100"
        scrollHint
        scrollHintPosition="right"
        breadcrumb={
          <Breadcrumb
            path={[
              {
                title: translations[`product_services_${locale}`],
                url: linkProductsServices,
              },
              { title: data[`title_${locale}`] },
            ]}
            theme="dark"
          />
        }
      />
      <ProductsServicesCinemaOverview data={hero} locale={locale} />
      <ProductsServicesCinemaFacilities
        data={menu}
        locale={locale}
        isCinema={false}
      />
      {data?.have_own_location ? (
        <ProductsServicesConcessionsLocation
          concessionId={data?.id}
          slug={data?.slug}
          concessionTitle={data && data[`title_${locale}`]}
        />
      ) : (
        <SectionFindCinema
          className="concession"
          title={data && data[`title_${locale}`]}
          concessionId={data?.id}
        />
      )}
    </>
  )
}
export default ConcessionDetailPage

export async function getStaticPaths() {
  const concessions = await getPostCategoriesByType("CONCESSION")
  const routesId = concessions?.map((item) => ({
    params: { slug: item?.slug },
    locale: "id",
  }))
  const routesEn = concessions?.map((item) => ({
    params: { slug: item?.slug },
    locale: "en",
  }))
  return { paths: [...routesEn, ...routesId], fallback: false }
}

export async function getStaticProps(ctx) {
  const { locale } = ctx
  const { slug } = ctx.params
  const data = await getPostCategoryBySlug(slug)
  const descMapping = () => {
    switch (slug) {
      case "xxi-cafe":
        return metaDesc[`concession_xxi_cafe_${locale}`]
      case "the-premiere-cafe":
        return metaDesc[`concession_premiere_cafe_${locale}`]
      case "xxi-lounge":
        return metaDesc[`concession_lounge_${locale}`]
      case "xxi-cafe-box":
        return metaDesc[`concession_cafe_box_${locale}`]
      case "the-ballroom":
        return metaDesc[`concession_ballroom_${locale}`]
      case "hello-sunday":
        return metaDesc[`concession_hello_sunday_${locale}`]
      default:
        return metaDesc[`product_landing_${locale}`]
    }
  }
  return {
    props: {
      seo: {
        title:
          data[`title_${locale}`] || translations[`product_services_${locale}`],
        description: descMapping(),
      },
      page: `detail-concession ${slug}`,
      data,
      locale,
    },
    revalidate: 60,
  }
}
